export default "__VITE_ASSET__BwWRBBKK__"